import { render, staticRenderFns } from "./ChangeStatusDialogComponent.vue?vue&type=template&id=3882bbe4"
import script from "./ChangeStatusDialogComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./ChangeStatusDialogComponent.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3882bbe4')) {
      api.createRecord('3882bbe4', component.options)
    } else {
      api.reload('3882bbe4', component.options)
    }
    module.hot.accept("./ChangeStatusDialogComponent.vue?vue&type=template&id=3882bbe4", function () {
      api.rerender('3882bbe4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/actions/ActionDialog/ChangeStatusDialogComponent.vue"
export default component.exports